module.exports = __webpack_public_path__ + "assets/img/11_737_big.eb83c33b.jpg";